import angular from 'angular';
import angularRoute from 'angular-route';
import vcRecaptcha from 'angular-recaptcha';

import SignupBasicAccountCtrl from './account/account-ctrl';
import SignupBasicConfirmationCtrl from './confirmation/confirmation-ctrl';
import routes from './signup-basic-routes.js';

export default angular.module('signupBasic', [angularRoute, vcRecaptcha])
    .controller('SignupBasicAccountCtrl', SignupBasicAccountCtrl)
    .controller('SignupBasicConfirmationCtrl', SignupBasicConfirmationCtrl)
    .config(routes)
    .name;



// WEBPACK FOOTER //
// ./signup-basic/signup-basic-module.js